import React from "react";
import "./Settings.css";
import TabView from "../../../../components/TabView";
import PayoutUpload from "./PayoutUpload";
import AllowedService from "./AllowedService";
import LimitCharges from "./LimitCharges";
import AllowedPaymentMethod from "./AllowedPaymentMethod";
import AllowedCurrency from "./AllowedCurrency";

export default function Settings() {
  return (
    <div className="gateway-settings pb-3">
      <TabView
        tabs={[
          {
            name: "Payout Upload",
            content: <PayoutUpload />,
          },
          {
            name: "Allowed Service",
            content: <AllowedService />,
          },
          {
            name: "Limit/Charges",
            content: <LimitCharges />,
          },
          {
            name: "Allowed Payment Method",
            content: <AllowedPaymentMethod />,
          },
          {
            name: "Allowed Currency",
            content: <AllowedCurrency />,
          },
        ]}
      />
    </div>
  );
}
